module.exports = __webpack_public_path__ + "img/logo-white.badc7e2d.png";